import {
  ref, computed,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'
import notesCategories from './notes-categories'

export default function useNotesList(props, ctx) {
  const loggedUser = computed(() => ctx.root.$store.getters['auth/getLoggedUser'])
  const loadingNotes = ref(false)
  const notesList = ref([])
  const userId = ctx.root.$route.params.id
  // const displayedNotes = ref(10)
  const categoryFilter = ref('All')
  const categories = ['All', ...notesCategories]
  // const notes = computed(() => notesList.value.slice(0, displayedNotes.value))
  const notes = computed(() => {
    if (categoryFilter.value === 'All') return notesList.value
    return notesList.value.filter(el => categoryFilter.value.toLowerCase() === el.category?.toLowerCase())
  })
  const fetchNotes = async () => {
    try {
      notesList.value = []
      loadingNotes.value = true
      const response = await ctx.root.$store.dispatch('notes/fetchNotesList', {
        notableType: props.notableType,
        notableId: userId,
      })
      notesList.value = response.data.notes
    } catch (error) {
      console.log(error)
    } finally {
      loadingNotes.value = false
    }
  }
  fetchNotes()
  const currDriver = computed(() => ctx.root.$store.getters['drivers/currentDriver'])
  const loading = ref(false)
  const showLegacyNotes = ref(false)
  const legacyNotesColumns = [
    {
      key: 'created_at',
      label: 'created at',
      formatter: val => formatDate(val),
    },
    {
      key: 'note',
      label: 'note',
    },
  ]
  const legacyNotesList = ref([])
  const fetchLegacyNotes = async () => {
    try {
      loading.value = true
      showLegacyNotes.value = true
      legacyNotesList.value = (await ctx.root.$store.dispatch('drivers/fetchLegacyNotes', currDriver.value.externalId)).data?.data?.data
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  return {
    fetchNotes,
    notesList,
    loadingNotes,
    loggedUser,
    // displayedNotes,
    notes,
    fetchLegacyNotes,
    showLegacyNotes,
    loading,
    legacyNotesColumns,
    legacyNotesList,
    categories,
    categoryFilter,
  }
}
